import React, { useState ,useEffect } from 'react';
import { Button, DatePicker, Input, Row, Col, Select, Table, message, Tooltip, Spin } from 'antd';
import axios from 'axios';
import AdminNavbar from '../Navbar/AdminNavbar'; // Add your Navbar component
import { AiFillFileExcel, AiFillFilePdf, AiOutlineFileText } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { PayExpense, PayPayment, PayRecieve } from '../Api/All_Api';
import TitleNavbar from '../Navbar/TitleNavbar';

const { Option } = Select;

const PayBasic = () => {
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY"];
    
  const role = sessionStorage.getItem('role');

  const branchId = sessionStorage.getItem('branchId');
    const sessionYear = sessionStorage.getItem('sessionYear');
    const year = sessionYear
  const navigate = useNavigate();
      useEffect(() => {
        if (!sessionYear) {
          sessionStorage.clear();
          navigate('/')
        }
      },[])

  const [date, setDate] = useState('');
  const [receiptData, setReceiptData] = useState([]);
  const [paymentTotal, setPaymentTotal] = useState(0);
  const [expenseData, setExpenseData] = useState([]);
  const [employeePaymentData, setEmployeePaymentData] = useState([]);
  const [profitOrLoss, setProfitOrLoss] = useState(0);
  const [loading, setLoading] = useState(false);
  const [Type, setType] = useState('1');
  const [errors, setErrors] = useState({
    fromDate: '',
    toDate: '',
    Type: ''
  });
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  // Fetch Receipt Data
  const fetchReceiptData = async () => {
    setLoading(true);
    const formattedDate = date ? dayjs(date).format('YYYY-MM-DD') : '';
    try {
      const response = await axios.get(`${PayRecieve}?branchId=${branchId}&accYear=${year}&date=${formattedDate}`);
      const data = Array.isArray(response.data) ? response.data : [];
      setReceiptData(data);
      const total = data.reduce((sum, item) => sum + item.receivedAmount, 0);
      setPaymentTotal(total);
      calculateProfitOrLoss(total);
    } catch (error) {
      console.error('Error fetching receipt data:', error);
      toast.error('Error fetching receipt data');
    } finally {
      setLoading(false);
    }
  };

  // Fetch Expense Data
  const fetchExpenseData = async () => {
    setLoading(true);
    const formattedDate = date ? dayjs(date).format('YYYY-MM-DD') : '';
    try {
      const response = await axios.get(`${PayExpense}?branchId=${branchId}&accYear=${year}&date=${formattedDate}`);
      const data = Array.isArray(response.data) ? response.data : [];
      setExpenseData(data);
      calculatePaymentTotal(data, employeePaymentData);
    } catch (error) {
      console.error('Error fetching expense data:', error);
      toast.error('Error fetching expense data');
    } finally {
      setLoading(false);
    }
  };

  // Fetch Employee Payment Data
  const fetchEmployeePaymentData = async () => {
    setLoading(true);
    const formattedDate = date ? dayjs(date).format('YYYY-MM-DD') : '';
    try {
      const response = await axios.get(`${PayPayment}?branchId=${branchId}&accYear=${year}&date=${formattedDate}`);
      const data = Array.isArray(response.data) ? response.data : [];
      setEmployeePaymentData(data);
      calculatePaymentTotal(expenseData, data);
    } catch (error) {
      console.error('Error fetching employee payment data:', error);
      toast.error('Error fetching employee payment data');
    } finally {
      setLoading(false);
    }
  };

  // Calculate Payment Total
  const calculatePaymentTotal = (expenseList, employeeList) => {
    const expenseTotal = Array.isArray(expenseList)
      ? expenseList.reduce((sum, item) => sum + item.amount, 0)
      : 0;
    const employeeTotal = Array.isArray(employeeList)
      ? employeeList.reduce((sum, item) => sum + item.amount, 0)
      : 0;

    const totalPayment = expenseTotal + employeeTotal;
    setPaymentTotal(totalPayment);  // Updates state asynchronously

    const receiptTotal = Array.isArray(receiptData)
      ? receiptData.reduce((sum, item) => sum + item.receivedAmount, 0)
      : 0;

    calculateProfitOrLoss(receiptTotal, totalPayment); // Pass latest totalPayment
};

const calculateProfitOrLoss = (receiptTotal, paymentTotal) => {
    setProfitOrLoss(receiptTotal - paymentTotal);
};


  // Handle form submission
  const handleSubmit = async () => {
    if (!date || !Type) {
      setErrors({
      date: !date ? 'date is required' : '',
      
        Type: !Type ? 'Type is required' : ''
      });
      return;
    }
    // Submit data logic goes here
    console.log('Form Submitted', { fromDate, toDate, Type });
  };
    //===================================
    const navbg = {
      backgroundColor:"#f79400",
      boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
      display: "flex",
      alignItems: "center",
      padding: "5px 10px",
      fontSize: "19px",
      color:"#fff"
    }
    const components = {
      header: {
        cell: ({ children, ...restProps }) => (
          <th
            {...restProps}
            style={{
              backgroundColor: "#000",
              color: "#fff",
              padding: "10px",
              fontSize: "13px",
              borderRadius: "0px",
            }}
          >
            {children}
          </th>
        ),
      },
      body: {
        row: ({ children, ...restProps }) => (
          <tr
            {...restProps}
            style={{
              backgroundColor: "#f0f7fd",
            }}
          >
            {children}
          </tr>
        ),
        cell: ({ children, ...restProps }) => (
          <td
            {...restProps}
            style={{
              padding: "8px",
            }}
          >
            {children}
          </td>
        ),
      },
    };
  
    const handleDownloadPDF = () => {
      setType("1"); // Type for PDF download
      handleSubmit();
    };
    
    const handleDownloadExcel = () => {
      setType("2"); // Type for Excel download
      handleSubmit();
    };
        
    return (
      <>
        <AdminNavbar />
        
        <div className="p-0 m-0">
          <div className="row m-0" style={navbg}>
            <div
              className="col-12"
              style={{ display: "flex", alignItems: "center", justifyContent: "start" }}
            >
              <span className="px-md-5"  style={{ flexGrow: 1 }}>
                <AiOutlineFileText /> &nbsp; Financial Outcome
              </span>
              <span  >
            <TitleNavbar/>
            </span>
            </div>
          </div>
    
          <div className='row m-0 p-0 pt-3'>
          <div className='col-12 col-md-2 col-lg-4'></div>
          <div className='col-12 col-md-8 col-lg-4 '>
              <div className="row px-md-5 mt-3  m-0">

                 <div className="col-12 pt-2 ">
                                  <div className="row m-0">
                                    <div className="col-3 p-0 lableStyle">
                                      <label className="labels"  style={{fontSize:16}}> Date: </label>
                                    </div>
                                    <div className="col-9 ">
                                    <DatePicker
                                        defaultValue={null}
                                        value={date}
                                        onChange={(value) => setDate(value)}
                                        className="w-100"
                                        format={dateFormatList}
                                      />
                                        {errors.date && (
                                          <div className="errorField">{errors.date}</div>
                                        )}
                                    </div>
                                  </div>
                                </div>
    {/* Action Buttons */}
    <div className="row m-1 p-4"  >
        <div className="col-4 ">
          <Button type="primary" onClick={fetchReceiptData}  disabled={loading} >  {loading ? <Spin size="small" /> : 'Receipt Data '} </Button>
        </div>
        <div className="col-4 ">
          <Button type="primary" onClick={fetchExpenseData} disabled={loading}>{loading ? <Spin size="small" /> : 'Expense Data '}</Button>
        </div>
        <div className="col-4">
          <Button type="primary" onClick={fetchEmployeePaymentData} disabled={loading} > {loading ? <Spin size="small" /> : 'Employee Payment Data '}</Button>
        </div>
      </div>
   
      </div>
        </div>
</div>


{/* Tables Side by Side */}
<div className="row m-0 p-2 mb-5 pt-md-0 mt-3">
  <div className="col-12 col-md-2"></div>
  <div className="col-12 col-md-8 py-3 shadow border" style={{ marginBottom: "50px", backgroundColor: "white" }}>
  <div
            className="col-12 px-md-5"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
  <div className="pt-4 pt-md-0" style={{ display: "flex", gap: "10px" }}>
              {/* <Tooltip title="Download PDF" placement="top">
                <div

                  style={{
                    cursor: 'pointer',
                    fontSize: '24px',
                    color: '#D32F2F',
                    marginBottom: 16
                  }}
                  onClick={handleDownloadPDF}
                >
                  <AiFillFilePdf />
                </div>
              </Tooltip>
              <Tooltip title="Download Excel" placement="top">
                <div

                  style={{
                    cursor: 'pointer',
                    fontSize: '24px',
                    color: 'green',
                    marginBottom: 16
                  }}
                  onClick={handleDownloadExcel}
                >
                  <AiFillFileExcel />
                </div>
              </Tooltip> */}
              </div></div>
    <div className="row m-0 p-3">
      {/* Receipt Data Table */}
      <div className="col-4">
        <h6>Receipt Data</h6>
        <Table
          dataSource={receiptData}
          columns={[
            { title: "Customer Name", dataIndex: "customerName", key: "customerName" },
            { title: "Received Amount", dataIndex: "receivedAmount", key: "receivedAmount" },
          ]}
          rowKey="id"
          pagination={false}
          components={components}
          summary={() => {
            const totalReceipt = receiptData.reduce(
              (sum, item) => sum + item.receivedAmount,
              0
            );
            return (
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={1} style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                  Total Receieved
                </Table.Summary.Cell>
                <Table.Summary.Cell style={{ fontWeight: "bold", backgroundColor: "#f0f0f0", textAlign: "right" }}>
                  {totalReceipt}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            );
          }}
        />
      </div>

      {/* Expense Data Table */}
      <div className="col-4">
        <h6>Expense Data</h6>
        <Table
          dataSource={expenseData}
          columns={[
            { title: "Account Name", dataIndex: "accountName", key: "accountName" },
            { title: "Amount", dataIndex: "amount", key: "amount" },
          ]}
          rowKey="id"
          pagination={false}
          components={components}
          summary={() => {
            const totalAmount = expenseData.reduce(
              (sum, item) => sum + item.amount,
              0
            );
            return (
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={1} style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                  Total Expense
                </Table.Summary.Cell>
                <Table.Summary.Cell style={{ fontWeight: "bold", backgroundColor: "#f0f0f0", textAlign: "right" }}>
                  {totalAmount}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            );
          }}
        />
      </div>
 

    {/* Employee Payment Data Table */}
   
      <div className="col-4">
        <h6>Employee Payment Data</h6>
        <Table
          dataSource={employeePaymentData}
          columns={[
            { title: "Employee Name", dataIndex: "employeeName", key: "employeeName" },
            { title: "Amount", dataIndex: "amount", key: "amount" },
          ]}
          rowKey="id"
          pagination={false}
          components={components}
          summary={() => {
            const totalAmount = employeePaymentData.reduce(
              (sum, item) => sum + item.amount,
              0
            );
            return (
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={1} style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                  Total Payment
                </Table.Summary.Cell>
                <Table.Summary.Cell style={{ fontWeight: "bold", backgroundColor: "#f0f0f0", textAlign: "right" }}>
                  {totalAmount}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            );
          }}
        />
      </div>
    </div>

    {/* Profit or Loss Section */}
    <div className="row m-0 p-3">
      <div className='col-12 col-md-2 col-lg-4'></div>
      <div className='col-12 col-md-8 col-lg-4'>
        <div className="row px-md-5 mt-3 m-0">
          <div className="col-8 text-center">
            <h3 style={{ color: "black" }}>Profit or Loss</h3>
            <h5>{profitOrLoss >= 0 ? "Profit" : "Loss"}: {Math.abs(profitOrLoss)}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    
          {/* Profit or Loss Section */}
        
          {/* Generate Report */}
          
  {/* <div className='col-12 col-md-2 col-lg-4'></div>
  <div className='col-12 col-md-8 col-lg-4'>
    <div className="row px-md-5 mt-3 m-0">
      <div className="col-12 pt-2">
        <div className="row m-0">
          <div className="col-3 p-0 lableStyle">
            <label className="labels" style={{ fontSize: 16 }}> Type: </label>
          </div>
          <div className="col-9 col-md-4">
            <Select value={Type} onChange={setType} className="w-100">
              <Option value="1">PDF</Option>
              <Option value="2">Excel</Option>
            </Select>
            {errors.Type && (
              <div className="errorField">{errors.Type}</div>
            )}
          </div>
        </div>
      </div>
      {/* Reduce padding here 
      <div className="row m-0 p-2"> {/* Adjusted padding 
        <div className="col-4 text-center">
          <Button type="primary" onClick={handleSubmit}>Generate Report</Button>
        </div>
      </div>
    </div>
  </div>  */}
</div> 
 


          
      </>
    );
    
};

export default PayBasic;
